import { render, staticRenderFns } from "./KrDecreasingWarning.vue?vue&type=template&id=59c01690&scoped=true&"
import script from "./KrDecreasingWarning.vue?vue&type=script&lang=js&"
export * from "./KrDecreasingWarning.vue?vue&type=script&lang=js&"
import style0 from "./KrDecreasingWarning.vue?vue&type=style&index=0&id=59c01690&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c01690",
  null
  
)

export default component.exports